// src/components/TransformSection.jsx
import React from "react";
import orig1 from "../assets/Original_Examples/1.jpeg";
import orig2 from "../assets/Original_Examples/2.png";
import orig3 from "../assets/Original_Examples/3.jpeg";
import gen1  from "../assets/Generated_Examples/1.jpeg";
import gen2  from "../assets/Generated_Examples/2.jpg";
import gen3  from "../assets/Generated_Examples/3.png";

export function TransformSection({ onCreateClick }) {
  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-12 bg-white font-poppins">
      <div className="max-w-7xl mx-auto text-center mb-8 sm:mb-12 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-3 sm:mb-4">
          Transform Photos Into Beautiful E-Cards
        </h2>
        <p className="text-lg sm:text-xl text-gray-600 px-4 sm:px-0">
          See how our AI transforms ordinary photos into stunning greeting cards
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 max-w-7xl mx-auto">
        {/* Example 1 */}
        <div className="bg-white rounded-xl overflow-hidden shadow-lg">
          <div className="p-3 sm:p-4 bg-gray-50">
            <h3 className="font-bold text-base sm:text-lg text-gray-800 mb-2">
              Family Photo to Holiday Card
            </h3>
          </div>

          {/* Original Photo */}
          <div className="p-4 bg-white">
            <div className="aspect-w-4 aspect-h-3 rounded-lg overflow-hidden">
              <img src={orig1} alt="Original 1" className="object-cover w-full h-full" />
            </div>
            <p className="text-center mt-2 text-gray-500 text-sm">
              Original Photo
            </p>
          </div>

          {/* Arrow */}
          <div className="flex justify-center my-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-indigo-500 transform-arrow"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </div>

          {/* Transformed Card */}
          <div className="p-4 bg-white">
            <div className="aspect-w-4 aspect-h-3 bg-gradient-to-br from-red-50 to-red-100 rounded-lg overflow-hidden">
              <img src={gen1} alt="Transformed 1" className="object-cover w-full h-full" />
            </div>
            <p className="text-center mt-2 font-bold text-red-600">
              Happy Holidays!
            </p>
            <p className="text-center text-sm text-red-500">
              With love, The Johnsons
            </p>
          </div>
        </div>

        {/* Example 2 */}
        <div className="bg-white rounded-xl overflow-hidden shadow-lg">
          <div className="p-4 bg-gray-50">
            <h3 className="font-bold text-lg text-gray-800 mb-2">
              Portrait to Birthday Card
            </h3>
          </div>

          {/* Original Photo */}
          <div className="p-4 bg-white">
            <div className="aspect-w-4 aspect-h-3 rounded-lg overflow-hidden">
              <img src={orig2} alt="Original 2" className="object-cover w-full h-full" />
            </div>
            <p className="text-center mt-2 text-gray-500 text-sm">
              Original Photo
            </p>
          </div>

          {/* Arrow */}
          <div className="flex justify-center my-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-indigo-500 transform-arrow"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </div>

          {/* Transformed Card */}
          <div className="p-4 bg-white">
            <div className="aspect-w-4 aspect-h-3 bg-gradient-to-br from-blue-50 to-purple-100 rounded-lg overflow-hidden">
              <img src={gen2} alt="Transformed 2" className="object-cover w-full h-full" />
            </div>
            <p className="text-center mt-2 font-bold text-purple-600">
              Happy Birthday!
            </p>
            <p className="text-center text-sm text-purple-500">
              Hope your day is magical
            </p>
          </div>
        </div>

        {/* Example 3 */}
        <div className="bg-white rounded-xl overflow-hidden shadow-lg">
          <div className="p-4 bg-gray-50">
            <h3 className="font-bold text-lg text-gray-800 mb-2">
              Couple Photo to Anniversary Card
            </h3>
          </div>

          {/* Original Photo */}
          <div className="p-4 bg-white">
            <div className="aspect-w-4 aspect-h-3 rounded-lg overflow-hidden">
              <img src={orig3} alt="Original 3" className="object-cover w-full h-full" />
            </div>
            <p className="text-center mt-2 text-gray-500 text-sm">
              Original Photo
            </p>
          </div>

          {/* Arrow */}
          <div className="flex justify-center my-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-indigo-500 transform-arrow"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </div>

          {/* Transformed Card */}
          <div className="p-4 bg-white">
            <div className="aspect-w-4 aspect-h-3 bg-gradient-to-br from-pink-50 to-pink-100 rounded-lg overflow-hidden">
              <img src={gen3} alt="Transformed 3" className="object-cover w-full h-full" />
            </div>
            <p className="text-center mt-2 font-bold text-pink-600">
              Happy Anniversary!
            </p>
            <p className="text-center text-sm text-pink-500">
              Celebrating your love
            </p>
          </div>
        </div>
      </div>

      <div className="text-center mt-8 sm:mt-12 px-4">
        <button 
          onClick={onCreateClick}
          className="w-full sm:w-auto bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg font-medium transition text-sm sm:text-base"
        >
          Transform Your Photo Now
        </button>
      </div>
    </section>
  );
}
